import { render, staticRenderFns } from "./CanteenBanner.vue?vue&type=template&id=952ef366&lang=pug&"
import script from "./CanteenBanner.vue?vue&type=script&lang=js&"
export * from "./CanteenBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports